import { styled } from 'styled-components';

// The heading text
export const Heading = styled.h2`
  color: var(--color-text-regular);
  font-size: var(--font-xl);
  font-weight: var(--font-weight-heading);
`;
